import { AnyAction } from 'redux';

const DATA_GRID_SETTINGS = 'DATA_GRID_DENSITY';
const DATA_GRID_NODE_ID = 'DATA_GRID_NODE_ID'

const initialState = { density: 'standard', nodeId: '1' };

export function setBinderViewSettings(dispatch: any, dataGridSettings: any) {
    dispatch({
        type: DATA_GRID_SETTINGS,
        data: dataGridSettings
    });
};

export function setBinderViewNodeId(dispatch: any, nodeIdSettings: any) {
    dispatch({
        type: DATA_GRID_NODE_ID,
        data: nodeIdSettings
    });
}

export const binderViewReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case DATA_GRID_SETTINGS: {
            const data = {
                ...state,
                density: action.data.density
            };
            return data;
        };
        case DATA_GRID_NODE_ID: {
            const data = {
                ...state,
                nodeId: action.data.nodeId
            };
            return data;
        }
        default:
            return state;
    }
};
